package com.kaihuoy.home.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.shared.data.User
import com.kaihuoy.components.common.*
import com.kaihuoy.components.common.*
import com.kaihuoy.web.router.AppRouterState

@Composable
fun ServiceScreen(user: User?, onLogout: () -> Unit) {
    PageLayout(greeting = getGreeting(user?.displayName), onLogout = onLogout) {
    Div(attrs = { style { padding(32.px, screenContentPadding()) } }) {

        H1(attrs = { style { marginBottom(8.px); display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px) } }) {
            TIcon("wrench"); Text(" Huoltokirjaus")
        }

        P(attrs = {
            style {
                marginBottom(32.px)
                color(KaihuTheme.TextSecondary)
                fontSize(1.05.em)
            }
        }) {
            Text("Huolto- ja korjaustöiden hallinta")
        }

        Div(attrs = {
            style {
                display(DisplayStyle.Grid)
                gridTemplateColumns("repeat(auto-fill, minmax(min(280px, 100%), 1fr))")
                gap(24.px)
            }
        }) {
            // Uusi huoltotyö
            DashboardCard(
                title = "Uusi huoltotyö",
                subtitle = "Kirjaa uusi huolto tai korjaus",
                icon = "engine",
                containerColor = KaihuTheme.CardBackground,
                onClick = {
                    AppRouterState.navigate("uusi_huolto")
                }
            )

            // Huoltokalenteri
            DashboardCard(
                title = "Huoltoilmoitukset",
                subtitle = "Ilmoita huollon tarpeesta ja seuraa tilannetta",
                icon = "speakerphone",
                containerColor = KaihuTheme.CardBackground,
                onClick = {
                    AppRouterState.navigate("huoltoilmoitukset")
                }
            )

            // Konekohtaiset huollot
            DashboardCard(
                title = "Konekohtaiset huollot",
                subtitle = "Huoltohistoria koneittain",
                icon = "truck",
                containerColor = KaihuTheme.CardBackground,
                onClick = {
                    AppRouterState.navigate("konehuollot")
                }
            )
        }

        // Info-alue
        Div(attrs = { style { marginTop(40.px); opacity(0.8) } }) {
            P {
                Text("Valitse yllä olevista toiminnoista huoltojen ja huoltoilmoitusten hallintaan.")
            }
        }
    }
    }
}